import $ from "jquery";
export const DataWrapper = (dataType, dataFormat) => {
    const getDataType = () => dataType;
    const getDataFormat = () => dataFormat;

    return {
        getDataType,
        getDataFormat
    };
}


export const Widget = (widgetId, widgetType, dataWrapper) => { //add hidden widget type
    var value;
    const getWidgetId = () => widgetId;
    const getWidgetType = () => widgetType;
    const getWidgetDataType = () => dataWrapper.getDataType();
    const getWidgetDataFormat = () => dataWrapper.getDataFormat();

    const getWidgetValue = function (widgetId, widgetType) {
        let idString = '#' + widgetId;
        switch (widgetType) {
            case "1":
                //console.log("Textbox");
                value = $(idString).val();
                return convertToArray(value);

            case "2":
                //console.log("Text area");
                value = $(idString).val();
                return convertToArray(value);

            case "3":
                //console.log("Radio button");
                value = $("input[name='" + widgetId + "']:checked").val();
                return convertToArray(value);

            case "4":
                //console.log("Check box");
                value = $(idString).val();
                return value;

            case "5":
                //console.log("Single select drop down");
                value = $(idString).val();
                return convertToArray(value);

            case "6":
                //console.log("Multi-select drop down");
                value = $(idString).val();
                // make value comman separated.                 
                var stringValue = [];
                var valueClone = value;
                
                stringValue.push([valueClone.slice(0, -1).join(', '), valueClone.slice(-1)[0]].join(valueClone.length < 2 ? '' : ' and '));
                return stringValue;
        }


    }

   const setWidgetValue = function (widgetId, widgetType, value) {
        let idString = '#' + widgetId;
        if (widgetType === 3 || widgetType === "3") {
            if (!value.includes(null)) {
                return $("input[name='" + widgetId + "'][value='" + value + "']").prop('checked', true);
            } else {
                return $("input:radio[name='" + widgetId + "']").each(function (i) {
                    this.checked = false;
                });

            }
        }
        if (widgetType === 6 || widgetType === "6") {
            if (value !== undefined && value !== null && value.length) {
                var valueStr = value + '';
				var modifiedValueStr = valueStr.replace('and', ',');
				var valuesArray = modifiedValueStr.trim().split(',')
                return $(idString).val(valuesArray.map(Function.prototype.call, String.prototype.trim));
            } else {
                $(idString + "> option").prop("selected", false);
            }


        } else {
            return $(idString).val(value);
        }
    }

    return {
        getWidgetId,
        getWidgetType,
        getWidgetDataType,
        getWidgetDataFormat,
        getWidgetValue,
        setWidgetValue
    };
}

export function convertToArray(value) {
    let val = new Array();
    val.push(value);
    return val;
}